export default "__VITE_ASSET__BOiU7xeG__"